import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/data/categories';

const articles = [
  {
    slug: '/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik',
    image: 'https://readdy.ai/api/search-image?query=Modern%20organized%20desk%20workspace%20with%20open%20laptop%20showing%20spreadsheet%20data%2C%20warm%20cream%20ceramic%20mug%20and%20notebook%2C%20soft%20natural%20window%20light%2C%20minimalist%20scandinavian%20home%20office%2C%20gentle%20sage%20green%20plant%20accent%2C%20calm%20productive%20atmosphere%2C%20editorial%20photography%20with%20warm%20amber%20tones&width=800&height=500&seq=blog-card-01-v2&orientation=landscape',
    badge: 'Nowość',
    badgeColor: 'bg-accent-100/80 text-accent-700',
    date: '15 lipca 2026',
    title: 'Kakobuy Spreadsheet Polska – Kompletny Przewodnik 2026',
    excerpt: 'Wszystko, co musisz wiedzieć o Kakobuy Spreadsheet: jak działa, jak znaleźć najlepsze produkty, ile kosztuje wysyłka do Polski i czy Kakobuy jest bezpieczny.',
    external: false,
  },
  {
    slug: '/artykul/czy-kakobuy-jest-bezpieczny',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20abstract%20shield%20integrated%20into%20warm%20minimalist%20interface%20on%20cream%20background%2C%20soft%20natural%20light%2C%20modern%20editorial%20photography%2C%20sage%20green%20and%20warm%20amber%20accents%2C%20calm%20trustworthy%20professional%20atmosphere&width=800&height=500&seq=blog-card-02-v2&orientation=landscape',
    badge: 'Bezpieczeństwo',
    badgeColor: 'bg-accent-100/80 text-accent-700',
    date: '14 lipca 2026',
    title: 'Czy Kakobuy jest bezpieczny? 10 rzeczy, które musisz wiedzieć',
    excerpt: 'Szczegółowa analiza bezpieczeństwa Kakobuy: ochrona kupujących, metody płatności, zdjęcia QC, ubezpieczenie przesyłek i zasady zwrotów.',
    external: false,
  },
  {
    slug: '/artykul/kakobuy-vs-sugargoo',
    image: 'https://readdy.ai/api/search-image?query=Balanced%20split%20comparison%20concept%20with%20two%20elegant%20abstract%20platform%20icons%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20warm%20amber%20and%20sage%20green%20tones%2C%20harmonious%20professional%20composition&width=800&height=500&seq=blog-card-03-v2&orientation=landscape',
    badge: 'Porównanie',
    badgeColor: 'bg-primary-100/70 text-primary-700',
    date: '13 lipca 2026',
    title: 'Kakobuy vs Sugargoo – Który agent zakupowy jest lepszy?',
    excerpt: 'Porównujemy Kakobuy i Sugargoo: ceny wysyłki, jakość zdjęć QC, interfejs, obsługa klienta i dostępność dla Polski.',
    external: false,
  },
  {
    slug: '/artykul/najlepsze-kakobuy-finds-2026',
    image: 'https://readdy.ai/api/search-image?query=Curated%20fashion%20discovery%20flat%20lay%20with%20trendy%20sneakers%20premium%20hoodie%20and%20stylish%20accessories%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20lifestyle%20photography%2C%20warm%20amber%20terracotta%20and%20sage%20palette%2C%20aspirational%20aesthetic&width=800&height=500&seq=blog-card-04-v2&orientation=landscape',
    badge: 'Finds 2026',
    badgeColor: 'bg-accent-100/80 text-accent-700',
    date: '12 lipca 2026',
    title: 'Najlepsze Kakobuy Finds 2026 – Ukryte perełki i best sellers',
    excerpt: 'Odkryj top produkty w kategoriach sneakersy, odzież, akcesoria i elektronika. Sprawdzone linki i porady.',
    external: false,
  },
  {
    slug: '/artykul/jak-dziala-kakobuy-spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20workspace%20with%20laptop%20displaying%20spreadsheet%20interface%20on%20screen%2C%20warm%20natural%20lighting%20from%20window%2C%20notebook%20with%20handwritten%20notes%20on%20cream%20desk%2C%20minimalist%20scandinavian%20home%20office%2C%20soft%20sage%20plant%20accent%2C%20productive%20calm%20atmosphere&width=800&height=500&seq=blog-card-05-v2&orientation=landscape',
    badge: 'Poradnik',
    badgeColor: 'bg-primary-100/70 text-primary-700',
    date: '11 lipca 2026',
    title: 'Jak działa Kakobuy Spreadsheet? Kompletny poradnik',
    excerpt: 'Krok po kroku wyjaśniamy, jak korzystać z arkusza – od wyboru kategorii po złożenie zamówienia przez Kakobuy.',
    external: false,
  },
  {
    slug: '/artykul/kakobuy-shipping-polska',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cardboard%20shipping%20box%20with%20kraft%20paper%20packing%20materials%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20minimalist%20product%20photography%2C%20organized%20preparation%20concept%2C%20warm%20beige%20and%20earthy%20tones%2C%20calm%20professional%20atmosphere&width=800&height=500&seq=blog-card-06-v2&orientation=landscape',
    badge: 'Wysyłka',
    badgeColor: 'bg-secondary-100/80 text-secondary-700',
    date: '10 lipca 2026',
    title: 'Kakobuy Shipping Polska – Koszty, czas i metody dostawy',
    excerpt: 'Wszystko o wysyłce do Polski: dostępne metody, orientacyjne ceny, czas oczekiwania i jak zaoszczędzić.',
    external: false,
  },
  {
    slug: '/artykul/najczestsze-bledy-kakobuy',
    image: 'https://readdy.ai/api/search-image?query=Thoughtful%20hand%20pausing%20over%20laptop%20keyboard%20on%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20modern%20minimalist%20workspace%2C%20gentle%20amber%20and%20sage%20tones%2C%20reflective%20educational%20mood%2C%20editorial%20photography%20with%20subtle%20depth%20of%20field&width=800&height=500&seq=blog-card-07-v2&orientation=landscape',
    badge: 'Porady',
    badgeColor: 'bg-accent-100/80 text-accent-700',
    date: '9 lipca 2026',
    title: 'Najczęstsze błędy przy korzystaniu z Kakobuy',
    excerpt: 'Poznaj 5 najczęstszych błędów początkujących i dowiedz się, jak ich unikać. Oszczędź sobie stresu i pieniędzy.',
    external: false,
  },
  {
    slug: '/artykul/kakobuy-spreadsheet-dla-poczatkujacych',
    image: 'https://readdy.ai/api/search-image?query=Welcoming%20beginner%20friendly%20workspace%20with%20open%20laptop%20and%20smartphone%20on%20warm%20cream%20desk%2C%20soft%20morning%20light%2C%20clean%20minimalist%20aesthetic%2C%20gentle%20sage%20plant%20accent%2C%20inviting%20calm%20atmosphere%2C%20warm%20amber%20tones%2C%20fresh%20start%20feeling&width=800&height=500&seq=blog-card-08-v2&orientation=landscape',
    badge: 'Dla początkujących',
    badgeColor: 'bg-primary-100/70 text-primary-700',
    date: '8 lipca 2026',
    title: 'Kakobuy Spreadsheet dla początkujących – 5 kroków',
    excerpt: 'Nigdy nie korzystałeś z Kakobuy? Ten prosty poradnik poprowadzi Cię od rejestracji do pierwszej paczki.',
    external: false,
  },
  {
    slug: '/artykul/kakobuy-vs-taobao',
    image: 'https://readdy.ai/api/search-image?query=Split%20comparison%20concept%20with%20two%20abstract%20ecommerce%20platform%20symbols%20side%20by%20side%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20warm%20amber%20and%20sage%20tones%2C%20balanced%20minimalist%20composition&width=800&height=500&seq=blog-card-09-v2&orientation=landscape',
    badge: 'Porównanie',
    badgeColor: 'bg-primary-100/70 text-primary-700',
    date: '7 lipca 2026',
    title: 'Kakobuy vs Taobao – Agent czy bezpośrednie zakupy?',
    excerpt: 'Porównujemy zakupy przez agenta Kakobuy z bezpośrednimi zakupami na Taobao. Która opcja jest lepsza?',
    external: false,
  },
  {
    slug: '/artykul/kakobuy-alternatywy',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20elegant%20abstract%20platform%20icons%20arranged%20in%20harmonious%20composition%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20warm%20amber%20sage%20and%20sand%20tones%2C%20modern%20professional%20aesthetic%20representing%20choice%20and%20variety&width=800&height=500&seq=blog-card-10-v2&orientation=landscape',
    badge: 'Alternatywy',
    badgeColor: 'bg-secondary-100/80 text-secondary-700',
    date: '6 lipca 2026',
    title: 'Kakobuy alternatywy – Najlepsze platformy 2026',
    excerpt: 'Poznaj alternatywy dla Kakobuy: Sugargoo, CSSBuy i inne. Sprawdź, która platforma jest dla Ciebie.',
    external: false,
  },
  {
    slug: mainSiteUrl,
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20fashion%20discovery%20concept%20with%20artistic%20flat%20lay%20of%20sneakers%20and%20streetwear%20items%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20lifestyle%20photography%2C%20warm%20terracotta%20and%20amber%20tones%2C%20energetic%20yet%20refined%20modern%20aesthetic&width=800&height=500&seq=blog-card-11-v2&orientation=landscape',
    badge: 'Poradnik',
    badgeColor: 'bg-primary-100/70 text-primary-700',
    date: '5 lipca 2026',
    title: 'Jak znaleźć najlepsze Kakobuy Finds? Strategie 2026',
    excerpt: 'Poznaj sprawdzone strategie wyszukiwania ukrytych perełek na chińskich platformach. Społeczności, filtry i narzędzia.',
    external: true,
  },
  {
    slug: mainSiteUrl,
    image: 'https://readdy.ai/api/search-image?query=Modern%20shopping%20satisfaction%20concept%20with%20abstract%20checkmark%20and%20product%20symbols%20on%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20warm%20amber%20and%20sage%20green%20accents%2C%20positive%20uplifting%20professional%20aesthetic&width=800&height=500&seq=blog-card-12-v2&orientation=landscape',
    badge: 'Opinie',
    badgeColor: 'bg-accent-100/80 text-accent-700',
    date: '1 lipca 2026',
    title: 'Czy warto używać Kakobuy? Opinie i doświadczenia użytkowników',
    excerpt: 'Zebraliśmy opinie polskich użytkowników Kakobuy. Sprawdź, co mówią o platformie, zanim zaczniesz zakupy.',
    external: true,
  },
];

export default function LatestFindsSection() {
  return (
    <section id="blog" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-3">
              Artykuły SEO
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              Kakobuy Spreadsheet – Poradniki, Porównania i Analizy
            </h2>
            <p className="text-foreground-600 text-sm mt-2 max-w-2xl">
              Kompletna baza artykułów o Kakobuy: poradniki zakupowe, porównania platform, analizy bezpieczeństwa i przewodniki dla początkujących.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, idx) => (
            article.external ? (
              <a
                key={idx}
                href={article.slug}
                target="_blank"
                rel="noopener nofollow"
                className="group bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-200/60 overflow-hidden transition-all"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${article.badgeColor}`}>
                      {article.badge}
                    </span>
                    <span className="text-xs text-foreground-500">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs leading-relaxed line-clamp-3 mb-3">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600">
                    Czytaj więcej
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </a>
            ) : (
              <Link
                key={idx}
                to={article.slug}
                className="group bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-200/60 overflow-hidden transition-all"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${article.badgeColor}`}>
                      {article.badge}
                    </span>
                    <span className="text-xs text-foreground-500">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs leading-relaxed line-clamp-3 mb-3">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600">
                    Czytaj więcej
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </Link>
            )
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-700 font-semibold text-sm rounded-full hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap border border-background-200"
          >
            Zobacz wszystkie artykuły
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}